'use strict'; //polyfills

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("babel-polyfill");

require("core-js/es/map");

require("core-js/es/set");

require("whatwg-fetch");

var es6Promise = _interopRequireWildcard(require("es6-promise"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRouterDom = require("react-router-dom");

var _history = require("history");

var _notFound = _interopRequireDefault(require("./components/not-found"));

var _footer = _interopRequireDefault(require("./components/footer"));

var _menuList = _interopRequireDefault(require("./components/menu-list"));

var _metaNav = _interopRequireDefault(require("./components/meta-nav"));

var _metaNavMobile = _interopRequireDefault(require("./components/meta-nav-mobile"));

var _selectionContainer = _interopRequireDefault(require("./components/selection-container"));

var _formContainer = _interopRequireDefault(require("./components/form-container"));

require("./lib/global-utils");

var _advancedFetch = _interopRequireDefault(require("./lib/advanced-fetch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

es6Promise.polyfill();
var customHistory = (0, _history.createBrowserHistory)();

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
  history: customHistory
}, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: '/',
  component: _selectionContainer.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: '/form',
  component: _formContainer.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
}))), document.getElementById('app'));

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_footer.default, null), document.getElementById('footer'));

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_menuList.default, null), document.getElementById('main-menu'));

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_metaNav.default, null), document.getElementById('meta-nav'));

_reactDom.default.render( /*#__PURE__*/_react.default.createElement(_metaNavMobile.default, null), document.getElementById('mobile-meta-nav')); //Mobile Nav


var mobileNavTrigger = document.getElementById('mobile-nav-trigger'),
    target = document.querySelector('[data-menu]');
mobileNavTrigger.addEventListener('click', function () {
  if (mobileNavTrigger.classList.contains('is-open')) {
    target.classList.remove('is-open');
    mobileNavTrigger.classList.remove('is-open');
  } else {
    target.classList.add('is-open');
    mobileNavTrigger.classList.add('is-open');
  }
});

window.onpopstate = function (e) {
  e.preventDefault();
  fetch('/api/form', {
    credentials: 'include',
    method: 'DELETE'
  }).then(_advancedFetch.default).then(function (response) {
    window.location.push = response.next;
  }).catch(function (err) {
    void 0;
  });
};


//////////////////
// WEBPACK FOOTER
// ./client/main.js
// module id = 222
// module chunks = 0